export function formatCountry(v: string | undefined) {
    return !!v ? v : '';
}

export default formatCountry;
